'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Selectors


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _navigationActions = require('../../reducers/navigationActions');

var _currentBoardIdSelector = require('../../reducers/currentBoardId/currentBoardIdSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        currentBoardId: (0, _currentBoardIdSelector.getCurrentBoardId)(state)
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchNavigateToBoard: function dispatchNavigateToBoard(_ref) {
            var boardId = _ref.boardId;
            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId }));
        }
    };
};

var ModalManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(ModalManager, _React$Component);

    function ModalManager() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, ModalManager);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ModalManager.__proto__ || Object.getPrototypeOf(ModalManager)).call.apply(_ref2, [this].concat(args))), _this), _this.closeModalAndNavigate = function () {
            var _this$props = _this.props,
                currentBoardId = _this$props.currentBoardId,
                dispatchModalClose = _this$props.dispatchModalClose,
                dispatchNavigateToBoard = _this$props.dispatchNavigateToBoard;

            dispatchModalClose && dispatchModalClose();
            dispatchNavigateToBoard({ boardId: currentBoardId });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ModalManager, [{
        key: 'render',
        value: function render() {
            return this.props.children ? _react2.default.cloneElement(this.props.children, {
                close: this.closeModalAndNavigate
            }) : null;
        }
    }]);

    return ModalManager;
}(_react2.default.Component)) || _class);


ModalManager.propTypes = {
    dispatchModalClose: _propTypes2.default.func,
    dispatchNavigateToBoard: _propTypes2.default.func,
    currentBoardId: _propTypes2.default.string,
    children: _propTypes2.default.node
};

exports.default = ModalManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/ModalManager.js
// module id = 713
// module chunks = 0